export const CRUD_ROUTE_STATE_ITEM_DEFAULTS = 'CRUD_ROUTE_STATE_ITEM_DEFAULTS';
export const CRUD_ROUTE_STATE_LIST = 'CRUD_ROUTE_STATE_LIST';